import Swiper from 'swiper';

export default () => {
  const swiperGalleryMobile = new Swiper('.image-gallery__swiper--mobile', {
    loop: false,
    autoHeight: true,
    speed: 600,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      bulletClass: 'swiper-pagination-hero-bullet',
      bulletActiveClass: 'swiper-pagination-hero-bullet-active',
    },
    watchOverflow: true,
  });

  const swiperGalleryDesktop = new Swiper('.image-gallery__swiper--desktop', {
    loop: false,
    speed: 600,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    watchOverflow: true,
  });

  const swiperThumbnails = new Swiper('.image-gallery__swiper-thumbnails', {
    loop: false,
    watchOverflow: true,
    freeMode: true,
    watchSlidesProgress: true,
    slidesPerView: 'auto',
    spaceBetween: 20,
    threshold: 10,
  });

  const swiperFull = new Swiper('.image-gallery__swiper-full', {
    loop: false,
    speed: 600,
    observer: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    watchOverflow: true,
    thumbs: {
      swiper: swiperThumbnails,
    },
  });

  const popupToggle = document.querySelectorAll('.popup-toggle');
  const popupClose = document.querySelectorAll('.image-gallery__popup-close');
  const swiperFullPopup = document.querySelector('.image-gallery__swiper-full');

  const showPopup = (event) => {
    event.preventDefault();
    const popup = document.getElementById(event.currentTarget.dataset.popupId);
    const index = event.target.dataset.imageIndex;
    if (!popup) return;
    swiperThumbnails.slideTo(index, 0);
    swiperFull.slideTo(index, 0);
    if (swiperFullPopup) swiperFullPopup.style.maxWidth = `${swiperFull.width}px`;
    popup.classList.add('active');
    document.body.classList.add('image-gallery-open');
  };

  const hidePopup = (event) => {
    event.preventDefault();
    const popups = document.querySelectorAll('.popup');
    document.body.classList.remove('image-gallery-open');
    if (swiperFullPopup) swiperFullPopup.style.maxWidth = 'none';
    popups.forEach((popup) => {
      popup.classList.remove('active');
    });
  };

  const onKeyDown = (event) => {
    if (event.code === 'Escape') hidePopup(event);
  };

  popupToggle.forEach((toggle) => {
    toggle.addEventListener('click', showPopup);
  });

  popupClose.forEach((toggle) => {
    toggle.addEventListener('click', hidePopup);
  });

  window.addEventListener('keydown', onKeyDown);

};
